export default __webpack_public_path__ + "static/media/pool.8add63db.svg";